import React, { useEffect, useState } from "react";
import { Outlet, Link, useNavigate, useLocation } from "react-router";
import myAccountCSS from "../../styles/myAccount/myAccount.module.scss";
import Globals from "../../utility/constants/appConstants";
import customerSummaryClient, {allCustomerSummaryClient} from "../../utility/apiClients/customer/customerSummaryClient";
import { useDispatch, useSelector } from "react-redux";
import OverlayLoader from "../loader/overlayLoader";
import { setCustomerInfo, setAllCustomers, setAllCustomersApiCalled} from "../../reduxStore/login/loginSlice";
import { setSelectedServiceAddress } from "../../reduxStore/myAccount/accountSummarySlice";

import { customerServiceNumberFormatted } from "../../utility/utils/formatter";
import {isMobile} from "../../utility/utils/deviceUtil";
import MissionStatusChecker from '../missionStatusChecker';
import missionStatusClient from '../../utility/apiClients/user/missionStatusClient';
import { setSelectedCustomer } from "../../reduxStore/login/loginSlice";

const MyAccount = () => {
  const location = useLocation();
  const labels = Globals.acc;
  const nav = useNavigate();

  const dispatch = useDispatch();
  
  const [allCusSummary, setAllCusSummary] = useState(null);
  
  const customerInfo = useSelector(
    (state) => state.login.customerInfo
  );

  const allCustomers = useSelector((state) => state.login.allCustomers) || [];
  const isOverlayLoading = useSelector(
    (state) => state.accountSummary.isOverlayLoading
  );
  const [customerSummaryData, setCustomerSummaryData] = useState(
    customerInfo?.[0] || null
  );

  const [selCusInfo, setSelCusInfo] = useState(null);
  const [missionDown, setMissionDown] = useState(false);
  
  const selAdd =  useSelector(
    (state) => state.accountSummary.selectedServiceAddress
  );

  let { displayPrePayButton, displayEasyPayButton } = useSelector(
    (state) => state.accountSummary
  );

  const myAccountTabs = {
    accountSummary: {
      title: "Account Summary",
      description: "Pay your balance or view your payment history.",
      id: "summary-tab",
      target: "summary",
      link: "account-summary",
    },
    payments: {
      title: "Payments",
      description: "Pay your balance or view your payment history.",
      id: "payment-tab",
      target: "payment",
      link: "payments",
    },
    serviceDetails: {
      title: "Service Details",
      description:
        "Get information about your plans or services and view invoices.",
      id: "service-tab",
      target: "service",
      link: "my-services",
    },
    accountSettings: {
      title: "Account Settings",
      description:
        "Manage your payments (including EasyPay), contact information and more.",
      id: "setting-tab",
      target: "setting",
      link: "account-settings",
    },
    myDocuments: {
      title: "My Documents",
      description: "View your summaries and other important documentation.",
      id: "document-tab",
      target: "document",
      link: "my-documents",
    },
    help: {
      title: "Help",
      description: "",
      id: "help-tab",
      target: "help",
      link: "",
    },
  };

  const tabActive = location.pathname.split("/")[2];
  
  const [activeTab, setActiveTab] = useState("accountSummary");

  const [custNum, setCustNum] = useState(null);
  
  const addressesWithCustomers = localStorage.getItem("serviceAddressesWithCustomerNumbers")
    ? JSON.parse(localStorage.getItem("serviceAddressesWithCustomerNumbers"))
    : [];
    
  

  const missionStatusCheck = async () => {
    try {
      const missionStatus = await missionStatusClient();
      return !["yes"].includes(String(missionStatus?.data).trim().toLowerCase());
    } catch (err) {
      console.error("Error checking mission status api:", err);
      return false;
    }
  };

  // get all customer summmary data for all customers for a user
  useEffect(() => {
    const getAllCustomers = async() => {
      const isMissionAvailable = await missionStatusCheck();
      if (!isMissionAvailable) {
        setMissionDown(true);
        return;
      }

      try{  
        const allcustomerSummary = await allCustomerSummaryClient();

        if (allcustomerSummary?.status && allcustomerSummary?.status === 401 ) {
          console.log("Unauthorized access - 401");
          localStorage.clear();
          nav("/login", { replace: true, state: { from: location } });
          return;
        }
        
        if (allcustomerSummary?.data === null || allcustomerSummary?.data === undefined ) {
          return;
        }

        
        let addrListwithID = [];
        if(allcustomerSummary.status === 200 && allcustomerSummary?.data?.Customers){
          allcustomerSummary?.data?.Customers.forEach((cus) => {
            cus?.ServiceAddresses.forEach((addr, index) => {
              let serviceAddress = addr.address;
              let customerNumber = cus.CustomerNumber;
              let addrID = addr.addressId;
              addrListwithID.push({
                id: serviceAddress + " | " + customerNumber + " | " + addrID,
                name: serviceAddress + " | " + customerNumber
              });
            });

            setAllCusSummary(addrListwithID);
            dispatch(setAllCustomers(allcustomerSummary?.data?.Customers || []));
            dispatch(setAllCustomersApiCalled(true));
          });
        }

      } catch(err){      }
    }
    getAllCustomers();

    return () => {
      dispatch(setAllCustomers(null));
      dispatch(setAllCustomersApiCalled(false));
    };
  }, []);
  
  const handleTabClick = (tabKey) => {
    window.scrollTo(0, 0);
    setActiveTab(tabKey);
  };

  useEffect(() => {
    setCustomerSummaryData(customerInfo?.[0] || null);
  }, [customerInfo]);

  useEffect(() => {
    for (const key of Object.keys(myAccountTabs)) {
      if (tabActive === myAccountTabs[key].link) {
        setActiveTab(key);
      }
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    setCustNum(selAdd
      ? selAdd.split(" | ")?.[1]
      : localStorage.getItem("customerNumbers")
      ? JSON.parse(localStorage.getItem("customerNumbers"))[0]
      : "User");

    let selectedCustomer = selAdd?.split(" | ")?.[1] || custNum || null;
    let selCus = null;
    if(selectedCustomer !== null){
      selCus = allCustomers.find((customer) => customer.CustomerNumber === selectedCustomer);
      
      setSelCusInfo(selCus);
    }

  }, [selAdd, allCustomers]);

  const getCustomerSummary = async (custNum) => {
    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setMissionDown(true);
      return;
    }

    try {
      const customerSummary = await customerSummaryClient(custNum);

      if (customerSummary?.status && customerSummary?.status === 401 ) {
        console.log("Unauthorized access - 401");
        localStorage.clear();
        nav("/login", { replace: true, state: { from: location } });
        return;
      }
      
      if (
        customerSummary?.data === null ||
        customerSummary?.data === undefined
      ) {
        return;
      }
      
      dispatch(setCustomerInfo(customerSummary?.data));
      setCustomerSummaryData(customerSummary?.data);
    } catch (err) {
    } finally {
    }
  };

  useEffect(() => {
    if (custNum) {
      dispatch(setSelectedCustomer(custNum));
      getCustomerSummary(custNum);
    }
  }, [custNum]);

  const handleAddressChange = (e) => {
    let selAddr = e.target.value;
    dispatch(setSelectedServiceAddress(selAddr));
  };

  return (
    <>
    {missionDown && <MissionStatusChecker />}
    <section className={myAccountCSS["mt-sm-72"]}>
      {isOverlayLoading && <OverlayLoader isOpen={true} />}
      <div className="container mt-4 mb-3">
        <div
          className={`row align-items-center ${myAccountCSS["user-info-card"]}`}
        >
          <div className="col-12 col-md-4 col-lg-4">
            <div className="row mb-lg-0">
            <div className={`col-12 col-md col-lg-12 ${myAccountCSS["user-name"]}`}>
              {labels.salutation}&nbsp;{selCusInfo?.BusinessName}
            </div>
            </div>
            <div className="row mb-lg-0">

              <div className={`col-12 col-md col-lg-12 ${myAccountCSS["cust-detail"]}`} >
                Customer Number:&nbsp;{selCusInfo?.CustomerNumber}
              </div>

              {selCusInfo?.CustomerSinceDate?.toString() !== "0" && (
                <div className={`col-12 col-md col-lg-12 ${myAccountCSS["cust-detail"]}`}>
                  Customer Since:&nbsp;{selCusInfo?.CustomerSinceDate}
                </div>
              )}

            </div>
          </div>
          <div className={`col-12 col-md-4 d-flex justify-content-center align-items-center gap-3 ${myAccountCSS["servie-dropdown-sec"]}`}>
            <div
              className={`col-12 col-md mb-10 mb-md-0 text-md-end ${myAccountCSS["service-addr"]}`}
            >
              Service Address:
            </div>
            <div className="col-12 col-md">
              <select
                className={`${myAccountCSS["service-addr-option"]} w-100 rounded-0`}
                aria-label="service address select"
                id="serviceAddressSelect"
                onChange={(e) => handleAddressChange(e)}
              >
                {allCusSummary === null && addressesWithCustomers.map((address, index) => {
                    
                    let addressValue = address;

                    return (
                      <option key={address+"_"+index} value={addressValue} selected={addressValue.includes(selAdd?.split(" | ")?.[0])}>
                        {address}
                      </option>
                    );
                  })
                }

                {allCusSummary &&
                  allCusSummary.length > 0 &&
                  allCusSummary.map((address) => {
                    
                    let addressValue = address.id;

                    return (
                      <option key={address.id} value={addressValue} selected={addressValue.includes(selAdd)}>
                        {address.name}
                      </option>
                    );
                  })}
               
              </select>
            </div>
          </div>
          <div className="col-12 col-md-4 d-flex gap-2">                  
            <div className="d-none d-md-block col-6">
              {displayPrePayButton && (
                <Link className="d-flex" to="/my-account/payments/prepay-payment">
                  <div
                    className={`${myAccountCSS["bg-yellow"]} d-flex flex-column flex-fill justify-content-center`}
                  >
                    <div className={myAccountCSS["font-italic"]}>
                      <strong>Pre</strong>Pay
                    </div>
                    <div className={myAccountCSS["prepay-text"]}>and save</div>
                  </div>
                  <div
                    className={`align-items-center ${myAccountCSS["bg-dark"]} d-flex text-center text-white`}
                  >
                    Go
                  </div>
                </Link>
              )}
            </div>

            <div className="d-none d-md-block col-6">
              {displayEasyPayButton && (
                <Link
                  className="d-flex border-0"
                  to={"/my-account/payments/easypay-payment"}
                >
                  <div
                    className={`${myAccountCSS["bg-lightdark"]} d-flex flex-column flex-fill justify-content-center`}
                  >
                    <div className={myAccountCSS["font-italic"]}>
                      <strong>Easy</strong>Pay
                    </div>
                    <div className={myAccountCSS["easypay-text"]}>
                      Set Up Automatic Payments
                    </div>
                  </div>
                  <div
                    className={`align-items-center ${myAccountCSS["bg-green"]} d-flex text-center text-white`}
                  >
                    Go
                  </div>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* user details strip end */}

              
      {/* for desktop */}
      {!isMobile() && <div className="react-router-outlet container d-none d-md-block">
        <div className="row">
          <div className="col-md-3 col-12" style={{ paddingRight: "0px" }}>
            <div className={`row ${myAccountCSS["account-summary"]}`}>
              <div className="col-12">
                <div className="nav flex-column nav-pills me-3" role="tablist">
                  {/* Generating tabs from myAccountTabs object */}
                  {Object.keys(myAccountTabs).map((key, index) => {
                    const tab = myAccountTabs[key];
                    return key === "help" ? (
                      <button
                        className={`nav-link ${
                          key === activeTab ? myAccountCSS["active"] : ""
                        }`}
                        id={tab.id}
                        data-bs-toggle="pill"
                        data-bs-target={`#${tab.target}`}
                        role="tab"
                        aria-controls={tab.target}
                        aria-selected={key === activeTab ? "true" : "false"}
                        style={{ cursor: "default" }}
                        key={key}
                      >
                        <span className={`d-block ${myAccountCSS["fs-20"]}`}>
                          {tab.title}
                        </span>
                        <span className={`d-block ${myAccountCSS["fs-12"]}`}>
                          {key === "help" ? (
                            <>
                              <a className={myAccountCSS["acc-help-email"]} href={`${process.env.REACT_APP_CMS_URL}/contact-us`} >
                                Contact us.
                              </a>
                              <br />
                              <br />
                              Call:{" "}
                              <a className={myAccountCSS["acc-help-contact"]} href={`tel:${customerServiceNumberFormatted}`} >
                                {customerServiceNumberFormatted}
                              </a>
                            </>
                          ) : (
                            ""
                          )}
                        </span>
                      </button>
                    ) : (
                      <Link
                        to={tab.link}
                        key={key}
                        onClick={() => handleTabClick(key)}
                        style={{
                          marginRight: `${key === activeTab ? "-15px" : "0px"}`,
                        }}
                      >
                        <button
                          className={`nav-link ${
                            key === activeTab ? myAccountCSS["active"] : ""
                          }`}
                          id={tab.id}
                          data-bs-toggle="pill"
                          data-bs-target={`#${tab.target}`}
                          role="tab"
                          aria-controls={tab.target}
                          aria-selected={key === activeTab ? "true" : "false"}
                        >
                          <span className={`d-block ${myAccountCSS["fs-20"]}`}>
                            {tab.title}
                          </span>
                          <span className={`d-block ${myAccountCSS["fs-12"]}`}>
                            {tab.description}
                          </span>
                        </button>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-9 col-12" style={{ paddingLeft: "0px" }}>
            <div className="tab-content">
              <Outlet />
            </div>
          </div>
        </div>
      </div>}

      {/* for mobile */}
      {isMobile() && <div className="react-router-outlet container-fluid d-md-none mt-4">
        <div className="row">
          <div className="col-md-9 col-12">
            <div className="tab-content">
              {/* Tab panes for mobile view */}
              {Object.keys(myAccountTabs).map((key) => {
                const tab = myAccountTabs[key];
                return (
                  <div
                    className={`tab-pane fade ${
                      key === activeTab ? "show active" : ""
                    }`}
                    id={tab.target}
                    role="tabpanel"
                    aria-labelledby={tab.id}
                    key={key}
                  >
                    <div className="row">
                      <div className="col-12">
                        <div className={myAccountCSS["card-info"]}>
                          <div className={myAccountCSS["tab-heading"]}>
                            {tab.title}
                          </div>
                          <div className={myAccountCSS["tab-description"]}>
                            {tab.description}
                          </div>
                        </div>
                      </div>
                    </div>
                      
                      {key === "help" ? (
                        <span className={`d-block text-center ${myAccountCSS["mobile-help"]}`}>
                          <a className={myAccountCSS["acc-help-email"]} href={`${process.env.REACT_APP_CMS_URL}/contact-us`} >
                            Contact us.
                          </a>
                          <br />
                          <br />
                          Call:{" "}
                          <a className={myAccountCSS["acc-help-contact"]} href={`tel:${customerServiceNumberFormatted}`} >
                            {customerServiceNumberFormatted}
                          </a>
                        </span>
                      ) : (
                        ""
                      )}
                  </div>
                );
              })}

              <Outlet />
            </div>
          </div>
          <div className="col-md-3 col-12 tg-mob-menu">
            <div className={`row ${myAccountCSS["account-summary-mob"]}`}>
              <div className="col-12 mt-4">
                <div className="nav flex-column nav-pills" role="tablist">
                  {/* Generating tabs from myAccountTabs object for mobile */}
                  {Object.keys(myAccountTabs).map((key) => {
                    const tab = myAccountTabs[key];
                    return (
                      <Link
                        to={tab.link}
                        onClick={() => handleTabClick(key)}
                        key={key}
                      >
                        <button
                          className={`nav-link`}
                          id={tab.id}
                          data-bs-toggle="pill"
                          data-bs-target={`#${tab.target}`}
                          role="tab"
                          aria-controls={tab.target}
                          aria-selected="false"
                        >
                          {tab.title}
                        </button>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
    </section>
    </>
  );
};

export default MyAccount;
